<div class="sidebar" [ngClass]="{ 'sidebar-collapse': !this.sidebarOpen }">
  <div class="sidebar-content">
    <div class="logo-container">
      <div fxLayout="row">
        <img
          *ngIf="this.sidebarOpen"
          src="assets/images/logos/moby.svg"
          alt=""
          class="logo"
          loading="lazy" />
        <img
          *ngIf="!this.sidebarOpen"
          src="assets/images/logos/moby-blanca.png"
          alt=""
          class="logo-whale"
          loading="lazy" />
      </div>
      <div class="btn-container__sidebar">
        <button
          class="button_primary"
          type="button"
          title="Abrir menu lateral"
          (click)="openCloseSidebar()">
          <div *ngIf="this.sidebarOpen" class="container__icons">
            <app-left-dobble-arrow-svg-icon></app-left-dobble-arrow-svg-icon>
          </div>
          <div *ngIf="!this.sidebarOpen" class="container__icons">
            <app-rigth-dobble-arrow-svg-icon></app-rigth-dobble-arrow-svg-icon>
          </div>
        </button>
      </div>
    </div>
  </div>
  <div
    class="navigation-container"
    [ngClass]="{ 'animation-items-menu': this.sidebarOpen }">
    <ul class="navigation-list">
      <li class="list-item">
        <span
          class="item-title"
          [ngClass]="{ 'padding-open': this.sidebarOpen }"
          href="#">
          {{ this.sidebarOpen ? 'RECURSOS HUMANOS' : 'RRHH' }}
        </span>
      </li>
      <mat-divider></mat-divider>
      <li class="list-item">
        <div class="item-container" [routerLinkActive]="['activedRoute']">
          <a class="item-link" routerLink="/dashboard" title="Ir a Dashboard">
            <svg
              width="12"
              height="9"
              viewBox="0 0 12 9"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.57157 2.14286C2.57157 1.97401 2.60482 1.80683 2.66944 1.65084C2.73405 1.49485 2.82876 1.35311 2.94814 1.23372C3.06753 1.11433 3.20927 1.01963 3.36526 0.955012C3.52125 0.890399 3.68844 0.857143 3.85728 0.857143C4.02612 0.857143 4.19331 0.890399 4.3493 0.955012C4.50529 1.01963 4.64703 1.11433 4.76642 1.23372C4.88581 1.35311 4.98051 1.49485 5.04513 1.65084C5.10974 1.80683 5.143 1.97401 5.143 2.14286C5.143 2.48385 5.00754 2.81088 4.76642 3.05199C4.5253 3.29311 4.19828 3.42857 3.85728 3.42857C3.51629 3.42857 3.18926 3.29311 2.94814 3.05199C2.70703 2.81088 2.57157 2.48385 2.57157 2.14286V2.14286ZM3.85728 0C3.28896 0 2.74392 0.225765 2.34205 0.627628C1.94019 1.02949 1.71443 1.57454 1.71443 2.14286C1.71443 2.71118 1.94019 3.25622 2.34205 3.65809C2.74392 4.05995 3.28896 4.28571 3.85728 4.28571C4.4256 4.28571 4.97065 4.05995 5.37251 3.65809C5.77437 3.25622 6.00014 2.71118 6.00014 2.14286C6.00014 1.57454 5.77437 1.02949 5.37251 0.627628C4.97065 0.225765 4.4256 0 3.85728 0ZM8.143 2.57143C8.143 2.3441 8.2333 2.12608 8.39405 1.96534C8.55479 1.80459 8.77281 1.71429 9.00014 1.71429C9.22747 1.71429 9.44549 1.80459 9.60623 1.96534C9.76698 2.12608 9.85728 2.3441 9.85728 2.57143C9.85728 2.79876 9.76698 3.01677 9.60623 3.17752C9.44549 3.33827 9.22747 3.42857 9.00014 3.42857C8.77281 3.42857 8.55479 3.33827 8.39405 3.17752C8.2333 3.01677 8.143 2.79876 8.143 2.57143ZM9.00014 0.857143C8.54548 0.857143 8.10945 1.03775 7.78796 1.35925C7.46647 1.68074 7.28585 2.11677 7.28585 2.57143C7.28585 3.02609 7.46647 3.46212 7.78796 3.78361C8.10945 4.1051 8.54548 4.28571 9.00014 4.28571C9.4548 4.28571 9.89083 4.1051 10.2123 3.78361C10.5338 3.46212 10.7144 3.02609 10.7144 2.57143C10.7144 2.11677 10.5338 1.68074 10.2123 1.35925C9.89083 1.03775 9.4548 0.857143 9.00014 0.857143V0.857143ZM0.428711 6.42857C0.428711 6.08758 0.56417 5.76055 0.805288 5.51943C1.04641 5.27832 1.37343 5.14286 1.71443 5.14286H6.00014C6.34113 5.14286 6.66816 5.27832 6.90928 5.51943C7.1504 5.76055 7.28585 6.08758 7.28585 6.42857V6.52457C7.28495 6.56383 7.28209 6.60302 7.27728 6.642C7.22844 7.05754 7.07379 7.45359 6.82814 7.79229C6.35928 8.43943 5.46785 9 3.85728 9C2.24757 9 1.35614 8.43943 0.885568 7.79229C0.640221 7.45351 0.485874 7.05746 0.437282 6.642C0.433015 6.60297 0.430156 6.56381 0.428711 6.52457V6.42857V6.42857ZM1.28585 6.50571V6.51171L1.28928 6.55371C1.32248 6.81906 1.42213 7.07172 1.579 7.28829C1.85843 7.67229 2.467 8.14286 3.85728 8.14286C5.24757 8.14286 5.85614 7.67229 6.13557 7.28829C6.29244 7.07172 6.39209 6.81906 6.42528 6.55371C6.42682 6.53946 6.42796 6.52517 6.42871 6.51086V6.42857C6.42871 6.31491 6.38356 6.2059 6.30319 6.12553C6.22281 6.04515 6.1138 6 6.00014 6H1.71443C1.60076 6 1.49175 6.04515 1.41138 6.12553C1.33101 6.2059 1.28585 6.31491 1.28585 6.42857V6.50571ZM9.00014 8.14286C8.49614 8.14286 8.083 8.06571 7.74871 7.93886C7.88613 7.68715 7.99015 7.4186 8.05814 7.14C8.28785 7.22657 8.593 7.28571 9.00014 7.28571C9.95928 7.28571 10.3527 6.95829 10.5259 6.71486C10.6271 6.57287 10.6913 6.4079 10.7127 6.23486L10.7144 6.21086C10.7135 6.15462 10.6906 6.10099 10.6505 6.06155C10.6104 6.0221 10.5564 5.99999 10.5001 6H8.10014C8.03686 5.68917 7.90509 5.39636 7.71443 5.14286H10.5001C11.0916 5.14286 11.5716 5.62286 11.5716 6.21429V6.22886C11.5705 6.26008 11.5683 6.29125 11.5647 6.32229C11.5284 6.64354 11.411 6.95029 11.2236 7.21371C10.8619 7.72029 10.1839 8.14286 9.00014 8.14286V8.14286Z"
                class="iconoFill" />
            </svg>
            <p *ngIf="this.sidebarOpen">Dashboard</p>
          </a>
        </div>
      </li>
      <li class="list-item">
        <div class="item-container">
          <a class="item-link">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.2857 2.14286C10.2857 1.57454 10.0599 1.02949 9.65809 0.627628C9.25622 0.225765 8.71118 0 8.14286 0H2.14286C1.57454 0 1.02949 0.225765 0.627628 0.627628C0.225765 1.02949 0 1.57454 0 2.14286V8.14286C0 8.71118 0.225765 9.25622 0.627628 9.65809C1.02949 10.0599 1.57454 10.2857 2.14286 10.2857H4.28571V9.42857H2.14286C1.80186 9.42857 1.47484 9.29311 1.23372 9.05199C0.992602 8.81088 0.857143 8.48385 0.857143 8.14286V3.42857H9.42857V3.65829C9.68917 3.80874 9.90557 4.02514 10.056 4.28574C10.2065 4.54633 10.2857 4.84194 10.2857 5.14286V2.14286ZM2.14286 0.857143H8.14286C8.48385 0.857143 8.81088 0.992602 9.05199 1.23372C9.29311 1.47484 9.42857 1.80186 9.42857 2.14286V2.57143H0.857143V2.14286C0.857143 1.80186 0.992602 1.47484 1.23372 1.23372C1.47484 0.992602 1.80186 0.857143 2.14286 0.857143V0.857143ZM8.57143 4.28571C8.3441 4.28571 8.12608 4.37602 7.96534 4.53677C7.80459 4.69751 7.71429 4.91553 7.71429 5.14286V11.1429C7.71429 11.3702 7.80459 11.5882 7.96534 11.7489C8.12608 11.9097 8.3441 12 8.57143 12C8.79876 12 9.01677 11.9097 9.17752 11.7489C9.33827 11.5882 9.42857 11.3702 9.42857 11.1429V5.14286C9.42857 4.91553 9.33827 4.69751 9.17752 4.53677C9.01677 4.37602 8.79876 4.28571 8.57143 4.28571ZM6 7.71429C5.77267 7.71429 5.55465 7.80459 5.39391 7.96534C5.23316 8.12608 5.14286 8.3441 5.14286 8.57143V11.1429C5.14286 11.3702 5.23316 11.5882 5.39391 11.7489C5.55465 11.9097 5.77267 12 6 12C6.22733 12 6.44535 11.9097 6.60609 11.7489C6.76684 11.5882 6.85714 11.3702 6.85714 11.1429V8.57143C6.85714 8.3441 6.76684 8.12608 6.60609 7.96534C6.44535 7.80459 6.22733 7.71429 6 7.71429ZM10.2857 6.85714C10.2857 6.62981 10.376 6.4118 10.5368 6.25105C10.6975 6.09031 10.9155 6 11.1429 6C11.3702 6 11.5882 6.09031 11.7489 6.25105C11.9097 6.4118 12 6.62981 12 6.85714V11.1429C12 11.3702 11.9097 11.5882 11.7489 11.7489C11.5882 11.9097 11.3702 12 11.1429 12C10.9155 12 10.6975 11.9097 10.5368 11.7489C10.376 11.5882 10.2857 11.3702 10.2857 11.1429V6.85714Z"
                class="iconoFill" />
            </svg>
            <p *ngIf="this.sidebarOpen">Métricas</p>
          </a>
        </div>
      </li>
      <li class="list-item">
        <div class="item-container">
          <a class="item-link">
            <svg
              width="12"
              height="13"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3 3.45459H5.18182M3 5.36368H6.27273"
                class="iconoStroke"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                d="M1 1.81818C1 1.60119 1.0862 1.39308 1.23964 1.23964C1.39308 1.0862 1.60119 1 1.81818 1H8.36364C8.58063 1 8.78874 1.0862 8.94218 1.23964C9.09562 1.39308 9.18182 1.60119 9.18182 1.81818V11.9091H1.81818C1.60119 11.9091 1.39308 11.8229 1.23964 11.6695C1.0862 11.516 1 11.3079 1 11.0909V1.81818ZM9.18182 6.45455C9.18182 6.30988 9.23928 6.17114 9.34158 6.06885C9.44387 5.96656 9.58261 5.90909 9.72727 5.90909H10.8182C10.9628 5.90909 11.1016 5.96656 11.2039 6.06885C11.3062 6.17114 11.3636 6.30988 11.3636 6.45455V11.0909C11.3636 11.3079 11.2774 11.516 11.124 11.6695C10.9706 11.8229 10.7624 11.9091 10.5455 11.9091H9.18182V6.45455Z"
                class="iconoStroke"
                stroke-linejoin="round" />
            </svg>
            <p *ngIf="this.sidebarOpen">Reportes</p>
          </a>
        </div>
      </li>
      <li class="list-item">
        <div class="item-container">
          <a class="item-link">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 2.57143C0 1.88944 0.270918 1.23539 0.753154 0.753154C1.23539 0.270918 1.88944 0 2.57143 0H9.42857C10.1106 0 10.7646 0.270918 11.2468 0.753154C11.7291 1.23539 12 1.88944 12 2.57143V9.42857C12 10.1106 11.7291 10.7646 11.2468 11.2468C10.7646 11.7291 10.1106 12 9.42857 12H2.57143C1.88944 12 1.23539 11.7291 0.753154 11.2468C0.270918 10.7646 0 10.1106 0 9.42857V2.57143ZM2.57143 0.857143C2.11677 0.857143 1.68074 1.03775 1.35925 1.35925C1.03775 1.68074 0.857143 2.11677 0.857143 2.57143V3.47829L5.57143 3.43286V0.857143H2.57143ZM6.42857 0.857143V7.71429H11.1429V2.57143C11.1429 2.11677 10.9622 1.68074 10.6408 1.35925C10.3193 1.03775 9.88323 0.857143 9.42857 0.857143H6.42857ZM11.1429 8.57143H6.42857V11.1429H9.42857C9.88323 11.1429 10.3193 10.9622 10.6408 10.6408C10.9622 10.3193 11.1429 9.88323 11.1429 9.42857V8.57143ZM5.57143 11.1429V4.29L0.857143 4.33543V9.42857C0.857143 9.88323 1.03775 10.3193 1.35925 10.6408C1.68074 10.9622 2.11677 11.1429 2.57143 11.1429H5.57143Z"
                class="iconoFill" />
            </svg>
            <p *ngIf="this.sidebarOpen">Onboarding</p>
          </a>
        </div>
      </li>
    </ul>
    <ul class="navigation-list marginTop">
      <li class="list-item">
        <span
          class="item-title"
          [ngClass]="{ 'padding-open': this.sidebarOpen }"
          href="#">
          {{ this.sidebarOpen ? 'VENTAS' : 'VNT' }}
        </span>
      </li>
      <mat-divider></mat-divider>
    </ul>
  </div>

  <div *ngIf="this.sidebarOpen; else darkMode" class="darkContainer">
    <mat-slide-toggle [(ngModel)]="dark" class="toggle">
      <span class="darkSpan">Modo oscuro</span>
    </mat-slide-toggle>
  </div>

  <ng-template #darkMode>
    <div class="darkContainer">
      <p class="darkText">DARK Mode</p>
    </div>
  </ng-template>
</div>
